// M02 恆等式 - 練習題數據
// 系統化結構，便於 Supabase 數據遷移

// 多項式展開練習題
export const M02_01_PROBLEMS = [
  {
    id: 'M02_01_P001',
    topicId: 'M02_01',
    question: "展開 (x + 3)(x + 5)",
    solution: "x² + 8x + 15",
    explanation: "使用FOIL法：First: x·x = x²，Outer: x·5 = 5x，Inner: 3·x = 3x，Last: 3·5 = 15，合併同類項: x² + 8x + 15",
    difficulty: 1,
    order: 1,
    steps: ["使用FOIL法", "First: x·x = x²", "Outer: x·5 = 5x", "Inner: 3·x = 3x", "Last: 3·5 = 15", "合併同類項: x² + 8x + 15"]
  },
  {
    id: 'M02_01_P002',
    topicId: 'M02_01',
    question: "展開 (2x - 1)(x + 4)",
    solution: "2x² + 7x - 4",
    explanation: "使用分配律：2x(x + 4) - 1(x + 4) = 2x² + 8x - x - 4 = 2x² + 7x - 4",
    difficulty: 2,
    order: 2,
    steps: ["使用分配律", "2x(x + 4) - 1(x + 4)", "= 2x² + 8x - x - 4", "= 2x² + 7x - 4"]
  },
  {
    id: 'M02_01_P003',
    topicId: 'M02_01',
    question: "展開 (x + 2)²",
    solution: "x² + 4x + 4",
    explanation: "使用完全平方公式 (a + b)² = a² + 2ab + b²",
    difficulty: 1,
    order: 3,
    steps: ["使用完全平方公式", "(a + b)² = a² + 2ab + b²", "= x² + 2(x)(2) + 2²", "= x² + 4x + 4"]
  },
  {
    id: 'M02_01_P004',
    topicId: 'M02_01',
    question: "展開 (x + 4)(x - 4)",
    solution: "x² - 16",
    explanation: "使用平方差公式 (a + b)(a - b) = a² - b²",
    difficulty: 1,
    order: 4,
    steps: ["使用平方差公式", "(a + b)(a - b) = a² - b²", "= x² - 4²", "= x² - 16"]
  },
  {
    id: 'M02_01_P005',
    topicId: 'M02_01',
    question: "展開 (x + 1)(x² - x + 1)",
    solution: "x³ + 1",
    explanation: "這是立方和的因式分解形式的逆運算",
    difficulty: 3,
    order: 5,
    steps: ["使用分配律", "x(x² - x + 1) + 1(x² - x + 1)", "= x³ - x² + x + x² - x + 1", "= x³ + 1"]
  }
];

// 平方恆等式練習題
export const M02_02_PROBLEMS = [
  {
    id: 'M02_02_P001',
    topicId: 'M02_02',
    question: "化簡 (x + 3)²",
    solution: "x² + 6x + 9",
    explanation: "使用 (a + b)² = a² + 2ab + b²，其中 a = x, b = 3",
    difficulty: 1,
    order: 1,
    steps: ["使用 (a + b)² = a² + 2ab + b²", "a = x, b = 3", "= x² + 2(x)(3) + 3²", "= x² + 6x + 9"]
  },
  {
    id: 'M02_02_P002',
    topicId: 'M02_02',
    question: "化簡 (2x - 5)²",
    solution: "4x² - 20x + 25",
    explanation: "使用 (a - b)² = a² - 2ab + b²，其中 a = 2x, b = 5",
    difficulty: 2,
    order: 2,
    steps: ["使用 (a - b)² = a² - 2ab + b²", "a = 2x, b = 5", "= (2x)² - 2(2x)(5) + 5²", "= 4x² - 20x + 25"]
  },
  {
    id: 'M02_02_P003',
    topicId: 'M02_02',
    question: "展開 (x + y)²",
    solution: "x² + 2xy + y²",
    explanation: "基本的完全平方公式",
    difficulty: 1,
    order: 3,
    steps: ["使用完全平方公式", "(a + b)² = a² + 2ab + b²", "= x² + 2xy + y²"]
  }
];

// 恆等式證明練習題
export const M02_03_PROBLEMS = [
  {
    id: 'M02_03_P001',
    topicId: 'M02_03',
    question: "證明 (a + b)² = a² + 2ab + b²",
    solution: "左邊 = (a + b)² = (a + b)(a + b) = a² + ab + ba + b² = a² + 2ab + b² = 右邊",
    explanation: "通過展開左邊證明等於右邊",
    difficulty: 2,
    order: 1,
    steps: ["展開左邊", "(a + b)² = (a + b)(a + b)", "使用分配律", "= a(a + b) + b(a + b)", "= a² + ab + ba + b²", "= a² + 2ab + b²", "等於右邊，恆等式成立"]
  },
  {
    id: 'M02_03_P002',
    topicId: 'M02_03',
    question: "證明 a² - b² = (a + b)(a - b)",
    solution: "右邊 = (a + b)(a - b) = a² - ab + ba - b² = a² - b² = 左邊",
    explanation: "通過展開右邊證明等於左邊",
    difficulty: 2,
    order: 2,
    steps: ["展開右邊", "(a + b)(a - b)", "使用FOIL法", "= a² - ab + ba - b²", "= a² - b²", "等於左邊，恆等式成立"]
  }
];

// 二次式因式分解練習題
export const M02_04_PROBLEMS = [
  {
    id: 'M02_04_P001',
    topicId: 'M02_04',
    question: "因式分解 x² + 5x + 6",
    solution: "(x + 2)(x + 3)",
    explanation: "尋找兩數相加為5，相乘為6：2 + 3 = 5, 2 × 3 = 6",
    difficulty: 2,
    order: 1,
    steps: ["尋找兩數相加為5，相乘為6", "2 + 3 = 5, 2 × 3 = 6", "所以 x² + 5x + 6 = (x + 2)(x + 3)"]
  },
  {
    id: 'M02_04_P002',
    topicId: 'M02_04',
    question: "因式分解 x² - 7x + 12",
    solution: "(x - 3)(x - 4)",
    explanation: "尋找兩數相加為-7，相乘為12：-3 + (-4) = -7, (-3) × (-4) = 12",
    difficulty: 2,
    order: 2,
    steps: ["尋找兩數相加為-7，相乘為12", "-3 + (-4) = -7, (-3) × (-4) = 12", "所以 x² - 7x + 12 = (x - 3)(x - 4)"]
  },
  {
    id: 'M02_04_P003',
    topicId: 'M02_04',
    question: "因式分解 x² + 8x + 16",
    solution: "(x + 4)²",
    explanation: "這是完全平方式，中間項 = 2×x×4 = 8x",
    difficulty: 2,
    order: 3,
    steps: ["這是完全平方式", "檢查：中間項 = 2×x×4 = 8x ✓", "所以 x² + 8x + 16 = (x + 4)²"]
  }
];

// 平方差恆等式練習題
export const M02_05_PROBLEMS = [
  {
    id: 'M02_05_P001',
    topicId: 'M02_05',
    question: "因式分解 x² - 16",
    solution: "(x + 4)(x - 4)",
    explanation: "識別為平方差：x² - 4² = (x + 4)(x - 4)",
    difficulty: 1,
    order: 1,
    steps: ["識別為平方差", "x² - 4² = (x + 4)(x - 4)"]
  },
  {
    id: 'M02_05_P002',
    topicId: 'M02_05',
    question: "因式分解 9x² - 25",
    solution: "(3x + 5)(3x - 5)",
    explanation: "識別為平方差：(3x)² - 5² = (3x + 5)(3x - 5)",
    difficulty: 2,
    order: 2,
    steps: ["識別為平方差", "(3x)² - 5² = (3x + 5)(3x - 5)"]
  },
  {
    id: 'M02_05_P003',
    topicId: 'M02_05',
    question: "因式分解 x⁴ - 1",
    solution: "(x² + 1)(x + 1)(x - 1)",
    explanation: "先用平方差，再進一步分解",
    difficulty: 3,
    order: 3,
    steps: ["先用平方差", "x⁴ - 1 = (x²)² - 1² = (x² + 1)(x² - 1)", "再分解 x² - 1", "= (x² + 1)(x + 1)(x - 1)"]
  }
];

// 畢氏恆等式練習題 (簡化版)
export const M02_10_PROBLEMS = [
  {
    id: 'M02_10_P001',
    topicId: 'M02_10',
    question: "若 sinθ = 3/5，求 cosθ（θ在第一象限）",
    solution: "cosθ = 4/5",
    explanation: "使用畢氏恆等式 sin²θ + cos²θ = 1",
    difficulty: 2,
    order: 1,
    steps: ["使用 sin²θ + cos²θ = 1", "(3/5)² + cos²θ = 1", "9/25 + cos²θ = 1", "cos²θ = 16/25", "因為θ在第一象限，cosθ > 0", "所以 cosθ = 4/5"]
  },
  {
    id: 'M02_10_P002',
    topicId: 'M02_10',
    question: "化簡 1 - sin²θ",
    solution: "cos²θ",
    explanation: "由畢氏恆等式直接得出",
    difficulty: 1,
    order: 2,
    steps: ["由畢氏恆等式 sin²θ + cos²θ = 1", "移項得 cos²θ = 1 - sin²θ"]
  }
];

// 匯總所有M02問題數據的函數
export const getAllM02Problems = () => {
  return [
    ...M02_01_PROBLEMS,
    ...M02_02_PROBLEMS,
    ...M02_03_PROBLEMS,
    ...M02_04_PROBLEMS,
    ...M02_05_PROBLEMS,
    ...M02_10_PROBLEMS
    // 其他主題的問題可以後續添加
  ];
};

// 根據主題ID獲取問題
export const getProblemsByTopicId = (topicId) => {
  const allProblems = getAllM02Problems();
  return allProblems.filter(problem => problem.topicId === topicId);
}; 